import { render } from "./WeekPlan.vue?vue&type=template&id=45ec9db0"
import script from "./WeekPlan.vue?vue&type=script&lang=js"
export * from "./WeekPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__